// extracted by mini-css-extract-plugin
export default {"container":"styles_container__c+Pdg","buttons":"styles_buttons__W8RJF","closeButton":"styles_closeButton__8kQFP"};